// extracted by mini-css-extract-plugin
export default {"overviewCard":"overviewTab_overviewCard__ie9CK","overviewImage":"overviewTab_overviewImage__ZrYku"};